import React from 'react'
import { Breadcrumbs } from '@design-systems/canvas-ui'
import { Link } from 'react-router-dom'

const SparkStyledBreadcrumbs = ({
  breadcrumbs,
}: {
  breadcrumbs: { content: string | React.ReactNode; to: string }[]
}) => {
  return (
    <Breadcrumbs className="hc8-pt-3x">
      {breadcrumbs?.map((breadcrumb, index) => (
        <Breadcrumbs.Item key={index} as={Link} to={breadcrumb.to}>
          {breadcrumb.content}
        </Breadcrumbs.Item>
      ))}
    </Breadcrumbs>
  )
}

export default SparkStyledBreadcrumbs
